export default "__VITE_ASSET__c132daf1__"